import { render, staticRenderFns } from "./LoaderKel.vue?vue&type=template&id=32e9745e&scoped=true&"
import script from "./LoaderKel.vue?vue&type=script&lang=js&"
export * from "./LoaderKel.vue?vue&type=script&lang=js&"
import style0 from "./LoaderKel.vue?vue&type=style&index=0&id=32e9745e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e9745e",
  null
  
)

export default component.exports